import { Component, Input, EventEmitter, Output, SimpleChange } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'ads-dropdownlist',
  templateUrl: './primitivedropdown.component.html',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: PrimitveDropdownComponent, multi: true },
  ]
})
export class PrimitveDropdownComponent implements ControlValueAccessor {
  public value: boolean = true;
  private onChange: (value: any) => void;
  public onTouched: () => void;

  public focused(e){
    this.onFocus.emit(e);
  }
  public blured(e){
    this.onBlur.emit(e);
    this.onTouched();
  }
  public valuechange(e) {
    this.onChange(this.value);
    this.valueChange.emit(e);
  }

  @Input() name: string = 'dropdown';
  @Input() placeholder: string = 'select';
  @Input() format: string;
  @Input() disabled: boolean = false;
  @Input() required: boolean = false;
  @Input() virtualScroll: boolean = false;
  @Input() data: any[] = [];
  @Input() style: string;
  @Input() panelStyle: string;
  @Input() filter: string;
  @Input() showClear: string;
  @Input() filterBy: string;

  @Input() class: string;

  @Output("onChange") valueChange: EventEmitter<any> = new EventEmitter<any>();
  @Output("onFocus") onFocus: EventEmitter<any> = new EventEmitter<any>();
  @Output("onBlur") onBlur: EventEmitter<any> = new EventEmitter<any>();

  options: any[] = [];
  writeValue(obj: any): void {
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  ngOnChanges(changes: SimpleChange) {
    if (typeof changes["data"] != "undefined") {
      this.options = [];
      for (let i = 0; i < changes["data"]["currentValue"].length; i++) {
        this.options.push({ label: changes["data"]["currentValue"][i], value: changes["data"]["currentValue"][i] });
      }

    }
  }
}
